import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Input } from "../components/ui/Input";
import { PublicPageFrame } from "../components/layout/PublicPageFrame";

const cardClass =
  "bg-white/[0.92] backdrop-blur-[8px] rounded-2xl shadow-2xl p-8 w-full border border-white/20";

export function RegisterPage() {
  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmar_password: "",
    razon_social: "",
    cif: "",
    direccion: "",
    poblacion: "",
    codigo_postal: "",
    pais: "España",
    persona_contacto: "",
    telefono: "",
    email_contacto: "",
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirmar_password) {
      setError("Las contraseñas no coinciden");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/register", {
        email: form.email.trim(),
        password: form.password,
        razon_social: form.razon_social.trim(),
        cif: form.cif.trim(),
        direccion: form.direccion.trim(),
        poblacion: form.poblacion.trim(),
        codigo_postal: form.codigo_postal.trim(),
        pais: form.pais.trim() || "España",
        persona_contacto: form.persona_contacto.trim(),
        telefono: form.telefono.trim(),
        email_contacto: form.email_contacto.trim(),
      });
      setSuccess(true);
    } catch (err: unknown) {
      const data =
        err && typeof err === "object" && "response" in err
          ? (err as { response?: { data?: { error?: string } } }).response?.data
          : null;
      setError(data?.error ?? "Error al registrar");
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <PublicPageFrame>
        <div className={`${cardClass} max-w-md text-center`}>
          <h1 className="text-xl font-semibold text-[#2C2C2C]">Solicitud enviada</h1>
          <p className="mt-4 text-gray-600">
            Nos pondremos en contacto contigo para activar tu cuenta.
          </p>
          <Link
            to="/login"
            className="mt-6 inline-block font-medium text-[#1A3AB8] hover:underline"
          >
            Ya tengo cuenta
          </Link>
        </div>
      </PublicPageFrame>
    );
  }

  return (
    <PublicPageFrame centered={false}>
      <div className={`${cardClass} max-w-lg mx-auto`}>
        <h1 className="mb-6 text-xl font-semibold text-[#2C2C2C]">Registro</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <Input
              label="Contraseña"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>
          <div>
            <Input
              label="Confirmar contraseña"
              type="password"
              name="confirmar_password"
              value={form.confirmar_password}
              onChange={handleChange}
              required
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Razón social</label>
            <input
              type="text"
              name="razon_social"
              value={form.razon_social}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">CIF</label>
            <input
              type="text"
              name="cif"
              value={form.cif}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Dirección</label>
            <input
              type="text"
              name="direccion"
              value={form.direccion}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Población</label>
              <input
                type="text"
                name="poblacion"
                value={form.poblacion}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Código postal</label>
              <input
                type="text"
                name="codigo_postal"
                value={form.codigo_postal}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
              />
            </div>
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">País</label>
            <input
              type="text"
              name="pais"
              value={form.pais}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Persona de contacto</label>
            <input
              type="text"
              name="persona_contacto"
              value={form.persona_contacto}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Teléfono</label>
            <input
              type="tel"
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-[#2C2C2C]">Email de contacto</label>
            <input
              type="email"
              name="email_contacto"
              value={form.email_contacto}
              onChange={handleChange}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C]"
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-[#1A3AB8] px-4 py-2.5 font-medium text-white hover:bg-[#15308a] disabled:opacity-50"
          >
            Enviar solicitud
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-600">
          <Link to="/login" className="font-medium text-[#1A3AB8] hover:underline">
            Ya tengo cuenta
          </Link>
        </p>
      </div>
    </PublicPageFrame>
  );
}
